import { render, staticRenderFns } from "./TransferRequest.vue?vue&type=template&id=3bad075c&scoped=true&"
import script from "./TransferRequest.vue?vue&type=script&lang=js&"
export * from "./TransferRequest.vue?vue&type=script&lang=js&"
import style0 from "./TransferRequest.vue?vue&type=style&index=0&id=3bad075c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad075c",
  null
  
)

export default component.exports